export const COMMON_LAND_NAME = 'Common Land';
export const RARE_LAND_NAME = 'Rare Land';
export const EPIC_LAND_NAME = 'Epic Land';
export const LEGENDARY_LAND_NAME = 'Legendary Land';
export const MYTHICAL_LAND_NAME = 'Mythical Land';
